export const themes = [
  {
    name: "indigo",
    title: "Indigo",
  },
  {
    name: "cupcake",
    title: "Cupcake",
  },
  {
    name: "neon",
    title: "Neon",
  },
  {
    name: "classic",
    title: "Classic",
  },
];
